import { apiResource } from '@/util/resources'

export default {
  state: {
    loading: false,
    initializing: false,
    initialized: false,
    paymentPending: false,
    frontPageActiveTab: 'tab-paymentplan',
    pendingOrders: [],
    hidePersonalInfo: true,
    hasJPVActiveDebtorNr: false,
    showDrawer: false,
    error: null,
    announcements: null,
    message: {
      text: '',
      type: '',
      show: false,
      translate: false,
      clickToDismiss: false
    }
  },
  mutations: {
    setMessage (state, payload) {
      state.message.text = payload.text
      state.message.type = payload.type
      state.message.clickToDismiss = false
      state.message.translate = false
      if (payload.clickToDismiss != null) {
        state.message.clickToDismiss = payload.clickToDismiss
      }
      if (payload.translate != null) {
        state.message.translate = payload.translate
      }
      state.message.show = true
    },
    hideMessage (state) {
      state.message.show = false
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setInitializing (state, payload) {
      state.initializing = payload
      state.initialized = !payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setPaymentPending (state, payload) {
      state.paymentPending = payload.status
      state.pendingOrders = payload.debtNrs
    },
    clearError (state) {
      state.error = null
    },
    setFrontPageActiveTab (state, payload) {
      state.frontPageActiveTab = payload
    },
    setHidePersonalInfo (state, payload) {
      let hide = false
      if (payload.length === 1 && payload[0].hidePersonalInfo === true) {
        hide = true
      }
      state.hidePersonalInfo = hide
    },
    setHasJPVActiveDebtorNr (state, payload) {
      state.hasJPVActiveDebtorNr = payload.hasJPVActiveDebtorNr
    },
    setShowDrawer (state, payload) {
      state.showDrawer = payload
    },
    setAnnouncements (state, payload) {
      state.announcements = payload
    }
  },
  actions: {
    clearError ({ commit }) {
      commit('clearError')
    },
    setShowDrawer ({ commit }, payload) {
      commit('setShowDrawer', payload)
    },
    toggleShowDrawer ({ state, commit }) {
      commit('setShowDrawer', !state.showDrawer)
    },
    getAnnouncements ({ state, commit }) {
      if (state.announcements === null) {
        apiResource.get('api/announcements').then((response) => {
          commit('setAnnouncements', response.data)
        }).catch((errorResponse) => {
          console.log(errorResponse)
        })
      }
    }
  },
  getters: {
    message (state) {
      return state.message
    },
    loading (state) {
      return state.loading
    },
    initializing (state) {
      return state.initializing
    },
    initialized (state) {
      return state.initialized
    },
    paymentPending (state) {
      return state.paymentPending
    },
    pendingOrders (state) {
      return state.pendingOrders
    },
    error (state) {
      return state.error
    },
    frontPageActiveTab (state) {
      return state.frontPageActiveTab
    },
    hidePersonalInfo (state) {
      return state.hidePersonalInfo
    },
    hasJPVActiveDebtorNr (state) {
      return state.hasJPVActiveDebtorNr
    },
    showDrawer (state) {
      return state.showDrawer
    },
    announcements (state) {
      return state.announcements
    },
    languages () {
      return [
        { 'text': 'FI', 'locale': 'fi', 'fullText': 'Suomeksi' },
        { 'text': 'SV', 'locale': 'se', 'fullText': 'På Svenska' },
        { 'text': 'EN', 'locale': 'en', 'fullText': 'In English' }
      ]
    }
  }
}
